import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import BodyClassName from 'react-body-classname';

import { H1, H2 } from 'components/core/Typography';
import { Text } from 'components/core/Text';
import { Link } from 'components/core/Link';
import { StarReview } from 'components/review/StarReview';
import { PhoneNumberButton } from 'components/contact/PhoneNumber';
import { HoursAndDirectionsModal } from 'components/facility/HoursAndDirectionsModal';
import { scrollToElement } from 'lib/helpers';

import './facilityDetails.scss';

export const enhance = compose(
	withStateHandlers({
		showingHoursAndDirections: false
	}, {
		toggleShowingHoursAndDirections: ({ showingHoursAndDirections }) => () => ({
			showingHoursAndDirections: !showingHoursAndDirections
		})
	}),
	withHandlers({
		fetchLocalPhoneNumber: ({
			getLocalPhoneNumberByZipCode, facilityZipCode
		}) => () => getLocalPhoneNumberByZipCode(facilityZipCode)
	}),
);

export function FacilityDetails(props) {
	return (
		<div className="facility-details-container">
			<H1 size="large" className="facility-name">{props.facilityName}</H1>
			<div className="facility-contact-container">
				<H2 className="facility-address">
					{props.locationText}
				</H2>
				<BodyClassName className="sf_6128_click_to_show_phone_number_variation">
					<PhoneNumberButton
						link
						phoneNumber={props.facilityPhoneNumber}
						unformattedPhoneNumber={props.unformattedFacilityPhoneNumber}
						size="standard"
						outline
					/>
				</BodyClassName>
			</div>
			{!props.isOutOfNetwork &&
				<div>
					<Link
						className="supporting-link"
						onClick={props.toggleShowingHoursAndDirections}
					>
						Get map & hours
					</Link>
				</div>
			}
			{!props.isOutOfNetwork &&
				<div>
					{(props.reviewCount === 0) &&
						<Link
							className="supporting-link"
							href={`/review.html?fid=${props.facilityId}`}
							rel="nofollow"
						>
							Leave a review
						</Link>
					}
					{(props.reviewCount !== 0) &&
						<StarReview
							showOutOf
							outOf={5}
							reviewCount={props.reviewCount || 0}
							rating={props.reviewAverage || 0}
							labelSize="tiny"
							labelComponent={(labelProps) => (
								<span>
									<Text
										size={labelProps.labelSize}
										className="review-count"
									>
										- based on
									</Text>
									<Text strong>
										<Link
											onClick={() => scrollToElement('#reviews')}
										>
											{labelProps.label}
										</Link>
									</Text>
								</span>
							)}
						/>
					}
				</div>
			}
			{!props.isOutOfNetwork &&
				<HoursAndDirectionsModal
					facilityId={props.facilityId}
					showing={props.showingHoursAndDirections}
					onClose={props.toggleShowingHoursAndDirections}
					onSubmit={props.onGetHoursAndDirections}
				/>
			}
		</div>
	);
}

FacilityDetails.propTypes = {
	facilityName: PropTypes.string.isRequired,
	facilityId: PropTypes.number.isRequired,
	reviewCount: PropTypes.number,
	facilityPhoneNumber: PropTypes.string,
	unformattedFacilityPhoneNumber: PropTypes.string,
	locationText: PropTypes.string,
	reviewAverage: PropTypes.number,
	toggleShowingHoursAndDirections: PropTypes.func,
	showingHoursAndDirections: PropTypes.bool,
	isOutOfNetwork: PropTypes.bool,
	onGetHoursAndDirections: PropTypes.func.isRequired
};

export default enhance(FacilityDetails);
